export default "__VITE_ASSET__DnFCOj$x__"